import { render, staticRenderFns } from "./Supplier-Setting.vue?vue&type=template&id=199afc76"
import script from "./Supplier-Setting.vue?vue&type=script&lang=js"
export * from "./Supplier-Setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports